import useSWRFetcher, { SWRFetchError } from "../fetcher";
import { useEffect, useState } from "react";
import useSWR from "swr";
import settings from "../../../../constants/settings";
import { InventoryBin } from "../../../../components/internal/parts/Bins/inventoryBinTypes";

export default function useBoardBin(boardId: string | null) {
  const fetcher = useSWRFetcher<InventoryBin>();
  const [cannotFindBin, setCannotFindBin] = useState(false);

  const {
    data: inventoryBin,
    error,
    mutate,
  } = useSWR<InventoryBin, SWRFetchError>(
    boardId === null
      ? null
      : `${settings.api_url}/inventory/bins/for-board/${boardId}`,
    fetcher,
    {
      shouldRetryOnError: (error: SWRFetchError) => {
        return error.status != 404;
      },
    },
  );

  useEffect(() => {
    setCannotFindBin(error?.status === 404);
  }, [error?.status]);

  return {
    inventoryBin: inventoryBin || null,
    loadingInventoryBin:
      boardId !== null && inventoryBin === undefined && !cannotFindBin,
    refreshBoardBin: () => void mutate(),
    cannotFindBin,
  };
}
